import { Service } from '@angular/core';

import { CorporateAccount } from '../../../domains/corporate-account/models';
import { AuthUser } from '../../../domains/profile/models';
import { DetailedProject } from '../../models';

@Service()
export class DataTransporterService {
  #corporateAccount?: CorporateAccount;
  #project?: DetailedProject;
  #user?: AuthUser;

  getCorporateAccount(): CorporateAccount | undefined {
    return this.#corporateAccount;
  }

  getProject(): DetailedProject | undefined {
    return this.#project;
  }

  getUser(): AuthUser | undefined {
    return this.#user;
  }

  setCorporateAccount(corporateAccount?: CorporateAccount): void {
    this.#corporateAccount = corporateAccount;
  }

  setProject(project?: DetailedProject): void {
    this.#project = project;
  }

  setUser(user: AuthUser): void {
    this.#user = user;
  }
}
